import MultiChipTextField from './MultiChipTextField'

export default MultiChipTextField
